import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { UpdateCartLineApiParameter } from "@insite/client-framework/Services/CartService";
import {
    DispatchBeginUpdateCartLine,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
    LoadCart,
    UpdateCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateCartLineParameter {
    cartId: string;
    onSuccess?: () => void;
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, cartLine: { ...props.parameter.cartLine, properties: {} } };
    for (const key in props.parameter.cartLine.properties) {
        if (key !== "multipleSaleQty" && key !== "roundingRule") {
            props.apiParameter.cartLine.properties[key] = props.parameter.cartLine.properties[key];
        }
    }
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateApiParameter,
    UpdateCartLine,
    LoadCart,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
];

const updateCartLine = createHandlerChainRunner(chain, "UpdateCartLine");
export default updateCartLine;
